import { render, staticRenderFns } from "./recordSKU.vue?vue&type=template&id=da23cb80&scoped=true"
import script from "./recordSKU.vue?vue&type=script&lang=js"
export * from "./recordSKU.vue?vue&type=script&lang=js"
import style0 from "./recordSKU.vue?vue&type=style&index=0&id=da23cb80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da23cb80",
  null
  
)

export default component.exports